var _g, _g2, _path, _path2, _path3, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "256px",
    width: "256px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297.50 297.50",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4dff00"
    },
    d: "M244.297,147.048l-19.95,112.86c-0.47,2.66-2.77,4.6-5.48,4.6h-36.03c-2.25,0-3.64-1.25-4.26-1.99 c-0.62-0.74-1.61-2.32-1.21-4.54l7.51-42.5h15.92c5.74,0,10.4-4.66,10.4-10.4c0-5.73-4.66-10.39-10.4-10.39h-12.25l8.43-47.64 H244.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4dff00"
    },
    d: "M276.467,57.508v44.24c0,13.52-11,24.51-24.52,24.51h-49.61l-37.3-93.27h86.91 C265.467,32.988,276.467,43.988,276.467,57.508z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f50025"
    },
    points: "142.647,32.988 179.957,126.258 157.037,126.258 119.727,32.988 "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.247,57.508v44.24c0,20.15-13.23,37.26-31.46,43.13l-20.97,118.65c-2.23,12.61-13.14,21.76-25.95,21.76h-36.03 c-7.81,0-15.16-3.43-20.18-9.42c-5.02-5.98-7.12-13.82-5.76-21.51l18.97-107.31h-25.87c-4.25,0-8.07-2.59-9.65-6.54 l-45.62-114.05c-1.28-3.2-0.89-6.83,1.04-9.68c1.94-2.86,5.16-4.57,8.61-4.57h147.57 C276.927,12.208,297.247,32.528,297.247,57.508z M276.467,101.748v-44.24c0-13.52-11-24.52-24.52-24.52h-86.91l37.3,93.27h49.61 C265.467,126.258,276.467,115.268,276.467,101.748z M224.347,259.908l19.95-112.86h-47.32l-8.43,47.64h12.25 c5.74,0,10.4,4.66,10.4,10.39c0,5.74-4.66,10.4-10.4,10.4h-15.92l-7.51,42.5c-0.4,2.22,0.59,3.8,1.21,4.54 c0.62,0.74,2.01,1.99,4.26,1.99h36.03C221.577,264.508,223.877,262.568,224.347,259.908z M179.957,126.258l-37.31-93.27h-22.92 l37.31,93.27H179.957z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.197,121.488c5.29,2.24,7.76,8.34,5.53,13.62c-1.68,3.97-5.53,6.35-9.58,6.35c-1.35,0-2.72-0.26-4.04-0.82 c-13.78-5.83-24.47-16.67-30.09-30.54c-5.63-13.86-5.52-29.08,0.31-42.86c2.23-5.29,8.33-7.76,13.62-5.53 c5.28,2.23,7.76,8.33,5.52,13.62c-3.66,8.67-3.73,18.24-0.19,26.96C74.807,111.008,81.537,117.828,90.197,121.488z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.647,165.388c5.29,2.23,7.76,8.33,5.53,13.62c-1.68,3.96-5.53,6.34-9.58,6.34c-1.35,0-2.72-0.26-4.04-0.82 c-52.65-22.26-77.38-83.2-55.13-135.85c2.24-5.28,8.33-7.76,13.62-5.52c5.29,2.23,7.76,8.33,5.53,13.61 C9.777,98.868,29.547,147.588,71.647,165.388z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.f13bf127ef1dd763e0e6a4dbfb941091.svg";
export { ForwardRef as ReactComponent };